// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  settings: {
    ROAZHON_URL: 'https://dev-roazhon.weudq-ds-kub.eu-de.containers.appdomain.cloud',
    BIMDATA_URL: 'https://api.bimdata.io',
    ribbon: 'dev',
  },
  documentation: {
    DOC_FR_URL: 'https://users.beyond-platform.com/homepage/beyond-insite',
    DOC_EN_URL: 'https://users-prod.beyond-platform.com/en/welcome/beyond-digitalsite-2/',
  },
  datadog: {
    enabled: false,
    site: 'datadoghq.eu',
    applicationId: '<DDOG_APPLICATION_ID>',
    clientToken: '<DDOG_CLIENT_ID>',
    service: '<DDOG_SERVICE_NAME>',
    sampleRate: 100,
    trackInteractions: true,
  },
  support_email: 'support-digital@sixense-group.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
